module.exports = __webpack_public_path__ + "static/media/canimolt_INEGI2025_02.d5738dc5.jpg";